import { render, staticRenderFns } from "./RankingTransformer1011.vue?vue&type=template&id=1ff6f10d&scoped=true&"
import script from "./RankingTransformer1011.vue?vue&type=script&lang=js&"
export * from "./RankingTransformer1011.vue?vue&type=script&lang=js&"
import style0 from "./RankingTransformer1011.vue?vue&type=style&index=0&id=1ff6f10d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff6f10d",
  null
  
)

export default component.exports